import type { ModuleWithProviders } from '@angular/core';
import { NgModule, inject } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GoogleAnalyticsApiService } from '@common/modules/gtm/google-analytics.service';
import { RouterSubscription } from '@common/modules/gtm/router-subscription.service';
import { EEnvTypes } from '@common/enums/env-types.enum';

import { GTM_MODULE_TOKEN } from '@common/modules/gtm/gtm.module.token';
import { ENV_MODULE_TOKEN } from '@common/modules/env';

@NgModule({
    providers: [RouterSubscription],
    imports: [CommonModule],
})
export class GtmModule {
    private routerSubscription = inject(RouterSubscription);

    constructor() {
        const env = inject<Record<string, string | boolean>>(ENV_MODULE_TOKEN);

        if (env.type === EEnvTypes.PROD || env.type === EEnvTypes.PRE) {
            this.routerSubscription.initSubs();
        }
    }

    static forRoot(test: string, env: Record<string, string | boolean>): ModuleWithProviders<GtmModule> {
        return {
            ngModule: GtmModule,
            providers: [
                {
                    provide: GTM_MODULE_TOKEN,
                    useValue: test,
                },
                {
                    provide: ENV_MODULE_TOKEN,
                    useValue: env,
                },
                RouterSubscription,
                GoogleAnalyticsApiService,
            ],
        };
    }
}
